import { map, forEach, filter, indexOf, get } from 'lodash';

const Map = map;
const ForEach = forEach;
const Filter = filter;
const IndexOf = indexOf;
const GetValue = get;

export { Filter, ForEach, IndexOf, Map, GetValue };